import { GridColDef, DataGrid } from "@mui/x-data-grid";
import CarType from "../../interfaces/car"
import { useTranslation } from "react-i18next";

type PropsType = {
	cars: CarType[];
	loading: boolean;
}


export default function TableSearch({ cars, loading }: PropsType) {
	const { t } = useTranslation();
	const columns: GridColDef<CarType>[] = [
		{
			field: 'chassis',
			headerName: t('chassis_number'),
			flex: 1,
			minWidth: 90,
		},
		{
			field: 'branch',
			headerName: t('branch'),
			flex: 1,
			minWidth: 120,
			renderCell: params => {
				return params.value.name
			}
		},
		{
			field: 'type',
			headerName: t('car_type'),
			flex: 2,
			minWidth: 150,
		},
		{
			field: 'color',
			headerName: t('color'),
		},
		{
			field: 'price',
			headerName: t('cost'),
			renderCell: (params) => {
				return params.value.toLocaleString();
			}
		},
	];
	return (
		<div>
			<DataGrid
				rows={cars}
				columns={columns}
				disableRowSelectionOnClick
				disableColumnFilter
				disableColumnSorting
				disableColumnMenu
				hideFooter
				loading={loading}
			/>
		</div>
	)
}
